import { CustomDropdownTemplate } from "themes/common/components";

function CustomDropdown(props) {
    return <CustomDropdownTemplate {...props} />;
}

export default CustomDropdown;
